import React, { useState } from "react";
import { X } from "lucide-react";
import AppDownloadLink from "./AppDownloadLink";
import { detectDevice, isPhone, isStandalone } from "../../hooks/useInstallPrompt";

const KEY = "ishukart_app_banner_closed";

// Phones only (not computers, not inside the app). Closing hides it for this visit only.
export const useAppBanner = () => {
  const [show, setShow] = useState(() => isPhone() && !isStandalone() && !sessionStorage.getItem(KEY));
  const close = () => { sessionStorage.setItem(KEY, "1"); setShow(false); };
  return { show, close };
};

export const AppBanner = ({ onClose, className = "" }) => {
  const [device] = useState(detectDevice);
  return (
    <div role="region" aria-label="Get the Ishukart app" data-testid="app-banner" className={`h-14 bg-white border-b border-slate-200 ${className}`}>
      <div className="h-full max-w-7xl mx-auto px-2 sm:px-6 lg:px-8 flex items-center gap-2.5">
        <button onClick={onClose} aria-label="Close" data-testid="app-banner-close" className="shrink-0 w-7 h-7 rounded-full text-slate-400 hover:text-slate-700 hover:bg-slate-100 flex items-center justify-center"><X size={15} /></button>
        <img src="/icons/icon-192.png" alt="" className="shrink-0 w-9 h-9 rounded-[10px] shadow-sm" />
        <div className="min-w-0 flex-1 leading-tight">
          <p className="text-[13px] font-semibold text-slate-900 truncate">Ishukart <span className="hidden sm:inline font-normal text-slate-500">— build apps by chatting with AI</span></p>
          <p className="text-[11px] text-slate-500 truncate">Free · Android &amp; iPhone</p>
        </div>
        <AppDownloadLink source="banner" device={device} testid="app-banner-get"
          className="shrink-0 h-8 px-4 rounded-full bg-sky-500 text-white text-[13px] font-semibold flex items-center hover:bg-sky-600 active:bg-sky-700 transition-colors">
          Get
        </AppDownloadLink>
      </div>
    </div>
  );
};

export default AppBanner;
